import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.identity';
import * as api from '../../../clients/api';

@Injectable()
export class ApiIdentityEffects {

    Identity$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_IDENTITY),
        mergeMap((x: ac.GetIdentityAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getIdentity().pipe(
                map((result: any) => {
                    return new ac.GetIdentityErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetIdentityFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AccountService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AccountService {
        if (this.service === null) {
            this.service = this.injector.get(api.AccountService);
        }
        return this.service;
    }
}
